/**
 * Body Part Color Coding System (Task 10.2)
 *
 * Provides consistent color coding for body parts across the application.
 */

import type { BodyPart } from '../stores/toolStore';

/**
 * Color palette for body parts
 */
export const BODY_PART_COLORS = {
  head: '#3b82f6', // Blue
  body: '#10b981', // Green
  arms: '#f97316', // Orange
  legs: '#a855f7', // Purple
  control: '#ef4444', // Red
} as const;

/**
 * Get the color for a body part
 * Groups left/right arms and legs into single colors
 */
export function getBodyPartColor(bodyPart: BodyPart): string {
  switch (bodyPart) {
    case 'head':
      return BODY_PART_COLORS.head;
    case 'body':
      return BODY_PART_COLORS.body;
    case 'leftArm':
    case 'rightArm':
      return BODY_PART_COLORS.arms;
    case 'leftLeg':
    case 'rightLeg':
      return BODY_PART_COLORS.legs;
    case 'control':
      return BODY_PART_COLORS.control;
    default:
      // Fallback for unknown body parts
      return '#6b7280'; // gray-500
  }
}

/**
 * Get the display name for a body part group
 */
export function getBodyPartGroup(bodyPart: BodyPart): string {
  switch (bodyPart) {
    case 'head':
      return 'Head';
    case 'body':
      return 'Body';
    case 'leftArm':
    case 'rightArm':
      return 'Arms';
    case 'leftLeg':
    case 'rightLeg':
      return 'Legs';
    case 'control':
      return 'Control';
    default:
      return 'Unknown';
  }
}
